import { useLang } from '@/i18n';
import EfSpec from 'elem/ui/ef-spec';
import EfTitle from 'elem/ui/ef-title';
import EfVideo from 'elem/ui/ef-video';
import { FC } from 'react';
import css from './index.module.scss';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.EU4');
    const cards = [
        {
            title: t('card1_title'),
            desc: t('card1_desc'),
            tip: t('card1_tip'),
            poster: 'https://websiteoss.ecoflow.com/upload/image/1724296083451/%E6%88%AA%E5%B1%8F2024-03-28%2016.22%203.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1724295841084/-d03c-495e-a999-6377abeb7a22.mp4',
        },
        {
            title: t('card2_title'),
            desc: t('card2_desc'),
            tip: t('card2_tip'),
            poster: 'https://websiteoss.ecoflow.com/upload/image/1724296083256/%E6%88%AA%E5%B1%8F2024-03-28%2016.22%202.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1724295852990/-9fdc-4e89-aeff-6dc7899229ff.mp4',
        },
    ];

    return (
        <div
            id="dp3-teaser-EU4"
            className={`${css.thecomp} dp3-teaser-EU4 dp3-teaser-full GtmModuleData-section`}
            data-section-id={'dp3-EU4'}
            data-section-title={t('title')}
        >
            <EfSpec className="spec-x" />
            <EfTitle className="big-title" hasAnimation={false}>
                {t('bigTitle')}
            </EfTitle>
            <EfSpec className="spec-x" />
            <EfTitle className="title" hasAnimation={false}>
                {t('title')}
            </EfTitle>
            <div className="cards-box">
                <ul className="cards">
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-img">
                                {/* <EfImg pc={card.pc} h5={card.h5} /> */}
                                <EfVideo pc={card.pc} autoPlay={true} loop={true} poster={card.poster} />
                            </div>
                            <div className="card-info">
                                <p className="card-title">{card.title}</p>
                                <p className="card-desc">{card.desc}</p>
                                <p className="card-tip">{card.tip}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default TheComp;
